import { useState, useLayoutEffect, useRef } from 'react';

export function useFormHook() {
  const [formHeight, setFormHeight] = useState(0);

  const formRef = useRef(null);

  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth < 1180) {
        const totalHeight = window.innerHeight;
        const elementHeight = formRef?.current?.clientHeight || 0;
        setFormHeight(totalHeight - elementHeight - 100);
      }
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return { formRef, formHeight };
}
